// localStorage config for the super-admin analytics page. Reads are defensive; writes are best-effort (never throw).
const STORAGE_KEY = 'systemAdminUIConfig';

export interface SelectedAccountRef {
  id: string;
  name?: string;
}

export interface SystemAdminUIConfig {
  // Legacy single-account fields, kept for back-compat.
  selectedAccountId?: string | null;
  selectedTab?: string;
  consolidatedAccounts?: SelectedAccountRef[];
  dateRange?: { from?: string; to?: string }; // YYYY-MM-DD
}

export function readSystemAdminUIConfig(): SystemAdminUIConfig {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as SystemAdminUIConfig) : {};
  } catch {
    return {};
  }
}

export function patchSystemAdminUIConfig(patch: Partial<SystemAdminUIConfig>): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readSystemAdminUIConfig(), ...patch }));
  } catch {
    // storage unavailable (private mode / quota) — persistence is best-effort
  }
}
